import { defineMessages } from 'react-intl';

const translations = {
  emptyMessage: {
    id: 'positionProductList.emptyMessage',
    defaultMessage: 'No products',
    description: 'Empty message of the position product list of the fulfilment location positions',
  },
};

export default defineMessages(translations);
